{
  "container": {
    "type": "string",
    "pseudoType": [
      "weakRef"
    ],
    "referencedMap": "components",
    "refTypes": [],
    "shouldCollect": false,
    "shouldValidate": false,
    "isTopLevelDataNode": false
  }
}

